import csbMedLogic from './csb-medical.js';
import ifpMedLogic from './ifp-medical.js';
import ifpDenLogic from './ifp-dental.js';

const isCignaCore = window.digitalData.page.pageInfo.isCore;
const currentHost = window.location.hostname;
const folderName = window.location.pathname;

let siteName;
if (currentHost.indexOf('campaigns') > -1) {
  siteName = 'campaigns-cigna-com';
} else if (currentHost.indexOf('cigna') > -1 && isCignaCore) {
  siteName = 'www-cigna-com';
} else {
  siteName = '';
}

let jsonFileName;
if (folderName.match(/(supplemental|csb)/gm)) {
  jsonFileName = 'csb-medical';
} else if (folderName.match(/(dental)/gm)) {
  jsonFileName = 'ifp-dental';
} else {
  jsonFileName = 'ifp-medical';
}
const jsonPath = `/static/${siteName}/json/campaigns/${jsonFileName}.json`;

export default () => {
  if (siteName.length) {
    fetch(jsonPath)
    .then(response => response.json())
    .then((data) => {
      const campaignData = data;
      if (folderName.match(/(supplemental|csb)/gm)) {
        csbMedLogic(campaignData);
      } else if (folderName.match(/(dental)/gm)) {
        ifpDenLogic(campaignData);
      } else {
        ifpMedLogic(campaignData);
      }
    });
  }
};



// WEBPACK FOOTER //
// ./node_modules/cigna-frontend/js/campaigns/index.js